import { DataBean } from "../DataBean";



export class PaymentItems extends DataBean {
    
    


    public async getPaymentItemCatalog(idPaymentHeader:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPaymentItemCatalog_Number", [idPaymentHeader]);
    }

    public async createPaymentItemstepone(idBudgetAccountantMovement:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_createPaymentItem_Number", [idBudgetAccountantMovement]);
    }

    public async createPaymentItem(idPaymentHeader:any,values:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.budgetaccountant.PaymentItem_createPaymentItem_Number_java.util.Map", [idPaymentHeader,values]);
    }
    public async createPaymentItemByIDBudgetAccountantMovement(idBudgetAccountantMovement:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_createPaymentItem_Number", 
            [idBudgetAccountantMovement]);
    }
  


}